'use client'

import { useEffect, useRef } from 'react'
import { sendSelectPromotionEvent } from '../../events/eec/selectPromotion/selectPromotion'
import type { Promotion } from '../../types/EEC'

type SelectPromotionProps = {
	readonly children: React.ReactNode
	readonly promotion: Promotion
	readonly className?: string
}

export const SelectPromotion = ({
	promotion,
	children,
	className,
}: SelectPromotionProps) => {
	const wrapperRef = useRef<HTMLDivElement>(null)

	function handleClick() {
		sendSelectPromotionEvent(promotion)
	}

	useEffect(() => {
		const wrapperElement = wrapperRef.current

		if (wrapperElement) {
			wrapperElement?.addEventListener('click', handleClick)
			wrapperElement?.addEventListener('keydown', handleClick)
		}

		return () => {
			wrapperElement?.removeEventListener('click', handleClick)
			wrapperElement?.removeEventListener('keydown', handleClick)
		}
	}, [])

	return (
		<div ref={wrapperRef} className={className}>
			{children}
		</div>
	)
}
